module.exports = __webpack_public_path__ + "static/media/center_focus_strong.4b64fd34.svg";